"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var useReward_1 = require("./useReward");
var Congratulations = function (_a) {
    var data = _a.data;
    var t = (0, next_intl_1.useTranslations)('lottery');
    var rewardToShow = (0, useReward_1.useReward)(data === null || data === void 0 ? void 0 : data.reward);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('congratulations')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('youTookAPlace'))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.placeContainer },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.place }, t('place')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.placeValue }, data === null || data === void 0 ? void 0 : data.place)),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.placeContainer },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.place }, t('prize')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.prize }, rewardToShow))))));
};
exports.default = Congratulations;
